import React from 'react'
import {
    Content,
    FigureLabel,
    MainImage,
    TagLine,
    TitleLine,
    SmallContentInner,
    SectionH3,
    SectionSpacer,
} from '../ProjectPage'
import { headerHeight } from '../../../ui-config'
import imgs from '../../../images'

export default class ZeroWaste {
    constructor() {
        this.title = 'ZeroWaste'
        this.galleryImage = 'zw_closeup'
    }

    component(props) {
        return (
            <Content>
                <SmallContentInner>
                    <TagLine style={{ marginTop: headerHeight.default + 10, top: 0 }}>
                        How might we help people form better recycling habits?
                    </TagLine>
                    <TitleLine style={{ top: 0 }} />
                    <MainImage style={{ marginBottom: 20 }} src={ imgs.zw_closeup } alt="smart trash can render" />
                    <SectionH3>Background</SectionH3>
                    <p><i>Each year, the average person produces <b>2,263lbs</b> of waste. Using best practices from behavioral economics, the ZeroWaste trashcan nudges you towards lower levels of waste production. Each time you empty your trashcan, the competition begins. In an analog meets digital way, the ZeroWaste trashcan compares your current usage with your average usage and the real-time usage of your neighbors. Best of all, Zero's AI helps you make smart decisions about what to recycle.</i></p>
                    <SectionSpacer />
                    <SectionH3>Contextual Interviews</SectionH3>
                    <p style={{ marginTop: 0 }}>During the first phase of this project, I conducted contextual interviews with the aim to find frustrations people faced around their home. These interviews led to the insights that people want to make environmentally responsible choices but (1) convenience often wins, (2) people have no idea how much trash they produce, and (3) few people know all the rules of recycling.</p>
                    <div>
                        <img src={ imgs.zw_journeymap } style={{ width: '100%' }} alt='journey maps of trash habits' />
                        <FigureLabel>Journey maps</FigureLabel>
                    </div>
                    <SectionSpacer />
                    <SectionH3>Design Iterations</SectionH3>
                    <p>Two mechanisms I hypothesized could change behavior were 1) a visual display that nudged people to throw out less waste and 2) a camera that helps identify if something is recyclable. After many design revisions and sketches I settled on and built a prototype out of wood, laser cut MDF and acrylic, programmable LED light strips, and a Raspberry Pi with an attached camera + speaker.</p>
                    <div style={{ marginBottom: '14px'}}>
                        <img src={ imgs.zw_dial_iterations } style={{ width: '100%' }} alt="display iterations" />
                        <FigureLabel>Dial iterations</FigureLabel>
                    </div>
                    <div style={{ marginBottom: '14px'}}>
                        <img src={ imgs.zw_foammock } style={{ width: '100%' }} alt="foamcore mockup" />
                        <FigureLabel>Sizing tests with foam core</FigureLabel>
                    </div>
                    <div style={{ marginBottom: '14px'}}>
                        <img src={ imgs.zw_wood } style={{ width: '100%' }} alt="in progress wood model" />
                        <FigureLabel>Model in progress</FigureLabel>
                    </div>
                    <div style={{ marginBottom: '14px'}}>
                        <img src={ imgs.zw_physicalproduct } style={{ width: '100%' }} alt="physical model" />
                        <FigureLabel>Final 1:1 scale model</FigureLabel>
                    </div>
                    <SectionSpacer />
                    <SectionH3>Testing Non-Physical Interactions</SectionH3>
                    <p>The final stage of this project was a deep dive into the interaction of the trashcan. To do this I created a separate "Wizard of Oz" prototype. This test device let me simultaneously see a live video of test users' trash and type out auditory responses. I placed this device by trash and recycle receptacles and took notes on the interactions between person and machine. The most interesting insight I noted was people's reluctance to admit when they were wrong. People often asked "why can't I recycle this?" Finally, I picked up on a sense of obligation talking to one of the participants after the study. They said to me, "If it's there, I feel like I should use it." That insight alone tells me this has the potential to change the behavior of at least some people.</p>
                    <div style={{ marginBottom: '14px'}}>
                        <img src={ imgs.zw_oz } style={{ width: '100%' }} alt="wizard of oz setup" />
                        <FigureLabel>Wizard of OZ</FigureLabel>
                    </div>
                    <div>
                        <img src={ imgs.zw_needfinding } style={{ width: '100%' }} alt="behind the wizard of oz device" />
                        <FigureLabel>Behind the curtain</FigureLabel>
                    </div>
                 </SmallContentInner>
            </Content>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/projects/active/ZeroWaste.js